export default {
  header: {
    notes: 'Header in create equipment dialog',
    message: 'Add Equipment',
  },
  steps: {
    general: {
      notes: 'Header of general step',
      message: 'General',
    },
    site: {
      notes: 'Header of site step',
      message: 'Site',
    },
  },
  error: {
    serialDoesNotExist: {
      notes: 'Error message displayed when the serial number does not exist',
      message: 'The serial number does not exist',
    },
    externalEquipmentNotValid: {
      notes:
        'Error message displayed when the equipment for the given serial number is not valid',
      message: 'The equipment for the given serial number is not valid',
    },
  },
};
